module.exports = __webpack_public_path__ + "logo-inverted.69a2bd0b7d492cab60c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-inverted.svg
// module id = 546
// module chunks = 2